import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

export type DropdownMenuProps = DropdownMenuPrimitive.DropdownMenuProps;

export const DropdownMenu = DropdownMenuPrimitive.Root;
